import { TeamMemberTableRowData, TeamTableRowType } from '../types';

export const getInitials = (rowData: TeamMemberTableRowData): string => {
  let initials = '';
  if (rowData.type === TeamTableRowType.user && !!rowData.name && rowData.name.firstName && rowData.name.firstName.length > 1) {
    initials = rowData.name.firstName.slice(0, 2);
    if (rowData.name.lastName) {
      initials = initials.substr(0, 1) + rowData.name.lastName[0];
    }
  } else if (rowData.type !== TeamTableRowType.team) {
    initials = rowData.email ? rowData.email.slice(0, 2) : '';
  }
  return initials.toUpperCase();
};

export const getFullName = (rowData: TeamMemberTableRowData): string => {
  let fullName = '';
  if (rowData.type === TeamTableRowType.user && rowData.name) {
    const { firstName, lastName } = rowData.name;
    if (firstName && !lastName) {
        fullName = firstName;
    } else if (firstName && lastName) {
      fullName = `${firstName} ${lastName}`;
    } else if (!firstName && !lastName) {
      fullName = rowData.email.substring(0, rowData.email.lastIndexOf('@'));
    }
  }
  return fullName;
};

export const getEntityId = (entity: TeamMemberTableRowData) => {
  return entity.type === TeamTableRowType.invite ? entity.inviteId :
    (entity.type === TeamTableRowType.user ? entity.userId : entity.accountId);
};

export const getNameTitle = (rowData: TeamMemberTableRowData): string => {
  let title = '';
  if (rowData.type === TeamTableRowType.team) {
    title = rowData.accountName;
  } else if (rowData.type === TeamTableRowType.user && rowData.name?.firstName) {
    const { firstName, lastName } = rowData.name;
    if (firstName && !lastName) {
      title = firstName;
    } else if (firstName && lastName) {
      title = `${firstName} ${lastName}`;
    }
  } else {
    title = getEmailLocalpart(rowData.email);
  }
  return title;
};

export const getEmailLocalpart = (email: string) => {
  return email.split('@')[0];
};
